export default __webpack_public_path__ + "static/media/mon_24.a521b560.png";